import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { BoxProps } from '@/components/Box';
import type { DataTestId } from '@/lib/tests';
import type { BreakpointsKeys } from '@/theme/types';

import * as S from './Container.styles';

export interface ContainerProps
  extends Omit<BoxProps, 'px'>, Partial<DataTestId> {
  children: React.ReactNode;
  disableGutters?: boolean;
  disableGuttersDesktop?: boolean;
  disableGuttersMobile?: boolean;
  maxWidth?: BreakpointsKeys;
  ref?: Ref<HTMLElement>;
}

export const Container = forwardRef(
  ({ children, maxWidth = 'lg', ...boxProps }: ContainerProps, ref) => {
    return (
      <S.Wrapper
        ref={ref}
        $maxWidth={maxWidth}
        {...boxProps}
        data-test-id='ContainerWrapper'
      >
        {children}
      </S.Wrapper>
    );
  },
);

Container.displayName = 'Container';
